module.exports = "pegasus/assets/blocks/column-3-tech.png";